import React from 'react'
import { Search } from 'react-feather'
import { useHistory } from 'react-router-dom'

const SearchInput = ({disabled}) => {
  const history = useHistory()

  const handleClick = () => {
    if(disabled){
      return
    } else {
      history.push('/search-results')
    }
  }

  return (
    <div className="flex items-center cursor-pointer w-full relative">
      <input
        className="input w-full border border-gray-400 rounded py-2 px-4"
        placeholder="Search..."
        style={{borderColor: '#ddd'}}
        disabled={disabled}
      />
      <Search
        style={{width: '16px', height: '16px', color: '#999'}}
        className={`absolute w-full right-0 mr-3`}
        onClick={handleClick}
      />
    </div>
  )
}

export { SearchInput }